/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@xilo-mono/common/config';
import { JsonbType } from './integration-mapping.service';

@Injectable({
  providedIn: 'root',
})
export class ImporterService {
  apiUrl = `${this.configService.apiUrl}/importer`;

  constructor(private http: HttpClient, private configService: ConfigService) {}

  uploadList(data: { formId: number; fields: any[] }, importData?:JsonbType) {
    return this.http.post(`${this.apiUrl}/upload-list`, { ...data, ...importData });
  }
}
